module.exports = __webpack_public_path__ + "static/media/screen.89990bfc.png";